var map = {
	"./aca.png": 57199,
	"./africa-practice.png": 14469,
	"./bank-of-industry.png": 15761,
	"./business-france.png": 45619,
	"./buycoins.png": 43638,
	"./european-investment-bank.png": 53639,
	"./european-investment-bank_dark-theme.png": 8882,
	"./future-africa.png": 54503,
	"./heineken.png": 8588,
	"./heineken_dark-theme.png": 78642,
	"./ihs.png": 98861,
	"./infra-credit.png": 29018,
	"./lightrock.png": 53627,
	"./luminate.png": 74021,
	"./mtn.png": 64039,
	"./mtn_dark-theme.png": 19027,
	"./nestle.png": 16054,
	"./nestle_dark-theme.png": 35565,
	"./nigeria-brewries.png": 88339,
	"./nsid.png": 34570,
	"./pac-holdings.png": 37276,
	"./paystack.png": 86225,
	"./piggyvest.png": 10510,
	"./pz-cussons.png": 12648,
	"./pz-cussons_dark-theme.png": 44757,
	"./reckitt.png": 75029,
	"./shell_dark-theme.png": 33044,
	"./sterling.png": 86352,
	"./sterling_dark-theme.png": 54062,
	"./udpn.png": 10736,
	"./united-state-mission-nigeria.png": 91462,
	"./unnamed.png": 7765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14631;